module.exports = __webpack_public_path__ + "media/images/varta/Varta_Properties-a87a9c16a8a1782f4f7cefbd625943d5.png";